import React, { useState } from 'react';

export default function TextInput({ onAnalyze, onBack, loading, error }) {
  const [projectName, setProjectName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (projectName.trim() && description.trim()) {
      onAnalyze(description, projectName);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={onBack} className="text-gray-400 hover:text-gray-600 text-sm">
          ← Volver
        </button>
        <h2 className="font-semibold text-gray-800">Escribir requerimiento</h2>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">{error}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del proyecto</label>
          <input
            type="text"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
            placeholder="Ej.: Portal de clasificación arancelaria"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Descripción del proyecto
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={12}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none resize-y"
            placeholder="Describe funcionalidades, integraciones, tecnologías, reglas de negocio, usuarios...&#10;&#10;Mientras más detalle, mejor la estimación."
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading || !projectName.trim() || !description.trim()}
          className="w-full py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? '🔄 Analizando con IA...' : '🤖 Analizar con IA'}
        </button>
      </form>
    </div>
  );
}
